/* tslint:disable */
/* eslint-disable */
/**
 * Control Online API
 * Control Online API
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
/**
 *
 * @export
 * @interface DeferredIncomeHistoryFundDto
 */
export interface DeferredIncomeHistoryFundDto {
  /**
   *
   * @type {string}
   * @memberof DeferredIncomeHistoryFundDto
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof DeferredIncomeHistoryFundDto
   */
  name: string;
}

export function DeferredIncomeHistoryFundDtoFromJSON(json: any): DeferredIncomeHistoryFundDto {
  return DeferredIncomeHistoryFundDtoFromJSONTyped(json, false);
}

export function DeferredIncomeHistoryFundDtoFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): DeferredIncomeHistoryFundDto {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    id: json["id"],
    name: json["name"],
  };
}

export function DeferredIncomeHistoryFundDtoToJSON(value?: DeferredIncomeHistoryFundDto | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    id: value.id,
    name: value.name,
  };
}
